import Graphic from "@arcgis/core/Graphic";
import MapView from "@arcgis/core/views/MapView";
import { MapStoreProps } from "./types/mapStoreProps";

let store: MapStoreProps = { selected: null };
let listeners: any = [];
let mapView: MapView | null = null;

export const mapStore = {
    setSelected(graphic: Graphic | null) {
        store = Object.assign({}, store);
        store.selected = graphic;
        emitChange();
    },
    subscribe(listener: any) {
        listeners = [...listeners, listener];
        return () => {
            listeners = listeners.filter((l: any) => l !== listener);
        };
    },
    getSnapshot() {
        return store;
    },
    getView() {
        return mapView;
    },
    setView(view: MapView | null) {
        mapView = view;
    }
}

function emitChange() {
    for (let listener of listeners) {
        listener();
    }
}
